// Loads the Clerk JS SDK from the URL configured via Vite env. We continue
// to use the script-loaded SDK (instead of @clerk/clerk-react) so the
// existing OAuth/transfer/sign-out logic in login.jsx and app.jsx keeps
// working unchanged. Only the source of the publishable key + script URL
// has moved from a hard-coded auth-config.js into import.meta.env.

const clerkConfig = window.AUTH_CONFIG?.clerk;
if (clerkConfig?.publishableKey && clerkConfig?.scriptUrl) {
  if (!window.Clerk && !document.querySelector("script[data-auth-provider='clerk']")) {
    const script = document.createElement("script");
    script.src = clerkConfig.scriptUrl;
    script.crossOrigin = "anonymous";
    script.setAttribute("data-clerk-publishable-key", clerkConfig.publishableKey);
    script.setAttribute("data-auth-provider", "clerk");
    document.head.appendChild(script);
  }
} else if (import.meta.env.DEV) {
  console.warn(
    "Clerk not configured — set VITE_CLERK_PUBLISHABLE_KEY and VITE_CLERK_SCRIPT_URL in .env.local"
  );
}
